import React, { useState, useEffect } from 'react';

const Donate = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);
  const toggleButtons = document.querySelectorAll('.close');
  const hiddenContent = document.querySelector('.overlay');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      hiddenContent.classList.remove('show');
    });
  });
  return (
    <div className='donate'>
      <h2>Donate to OCD New York</h2>
      {pages.map((page) => {
        if (page.slug === 'donate') {
          return <div className='inner' dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        }
      })}
    </div>    
  );
}

export default Donate;